module.exports = __webpack_public_path__ + "media/components/country-flag/static/jp-b5f5f3391e63db35d1d2f50746c4080a.svg";